class HamburgerEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const SpTrigger = document.querySelector('.header__hum');
    const SpMenu = document.querySelector('.spMenu');
    const Overlay = document.querySelector('.spMenu__overlay');
    const Header = document.querySelector('.js-header');
    const body = document.querySelector('body');

    SpTrigger.addEventListener('click', () => {
      SpTrigger.classList.toggle('is-active')
      SpMenu.classList.toggle('is-active')
      Overlay.classList.toggle('is-active')
      Header.classList.toggle('is-active')
      body.classList.toggle('no-scroll')
    });
  }
}
